import styled from 'styled-components/macro';
import { colourPrimaryDarkPurple } from '../../../styling/colours';
import { fontSize03 } from '../../../styling/fonts';
import { spacing02 } from '../../../styling/spacing';

type Props = {
  title?: string;
  children: string;
};

export const DescriptionBlock = ({ title, children }: Props) => {
  return (
    <>
      {title && <RedHeader>{title}</RedHeader>}
      <Description>{children}</Description>
    </>
  );
};

const RedHeader = styled.h2`
  color: ${colourPrimaryDarkPurple};
  font-size: 13px;
  margin: ${spacing02} 0;
`;

const Description = styled.p`
  font-size: ${fontSize03};
  margin: ${spacing02} 0;
`;
